import { RefreshCw } from 'lucide-react';
import { Button } from '@roger/ui-components';
import { PermissionSlug } from '../../constants/featureFlags';
import { useStore } from '../../store';
import { useEOEClaimsManagerRegenerate } from './EOEClaimsManagerContext';
import { useEOEClaimsManagerTab } from './eoeClaimsManagerTabContext';

/**
 * Re-runs billing cycle creation (and recreates periods whose cycles were
 * voided). Only the Not Ready and Ready tabs show it: those are the tabs whose
 * contents the run can change. Needs claims:submit, mirroring the
 * backend gate on the endpoint, so nobody is shown a control that answers 403.
 */
export function RegenerateClaimsButton() {
  const regenerate = useEOEClaimsManagerRegenerate();
  const tabId = useEOEClaimsManagerTab();
  const canSubmitClaims = useStore(state =>
    state.hasPermission(PermissionSlug.CLAIMS_SUBMIT)
  );
  if (
    !canSubmitClaims ||
    !regenerate ||
    (tabId !== 'not-ready' && tabId !== 'ready')
  ) {
    return null;
  }
  return (
    <Button
      type='button'
      variant='outline'
      size='sm'
      onClick={regenerate.regenerate}
      disabled={regenerate.isRegenerating}
      className='col-span-2 justify-self-start md:col-auto'
    >
      <RefreshCw
        className={`mr-1 h-3 w-3${regenerate.isRegenerating ? ' animate-spin' : ''}`}
      />
      Regenerate claims
    </Button>
  );
}
